import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup } from '@angular/forms';

import { makeMap } from '@shared/core';
import { EditAccountUserRequest } from '@shared/account/models';
import { UserLocationRole } from '@shared/user/enums';
import {
  LocationInfo,
  UserWithAccount,
} from '@tablesready/common-ui';
import { CheckboxGroup } from '@tablesready/checkbox-group';
import { ButtonColorsEnum } from '@tablesready/button-group-control';
import { FrontendModalService } from '@tablesready/frontend-modal';
import { AppIcon } from '@tablesready/frontend-icons';

@Component({
  selector: 'tablesready-assign-location',
  templateUrl: './assign-location.component.html',
})
export class AssignLocationComponent implements OnInit {
  @Input() user: UserWithAccount;
  @Input() locations: LocationInfo[];

  icon = AppIcon;
  form: FormGroup;
  inProgress = false;
  buttonColors = ButtonColorsEnum;
  locationsToDisplay: CheckboxGroup[] = [];
  roles = [
    {
      name: 'USER',
      value: UserLocationRole.user,
    },
    {
      name: 'MANAGER',
      value: UserLocationRole.manager,
    },
  ];

  constructor(
    private readonly fb: FormBuilder,
    private readonly modalController: FrontendModalService,
  ) {}

  ngOnInit(): void {
    const locationUsersMap = makeMap(this.user.locationUsers, 'locationId');

    for (let location of this.locations) {
      const locationUser = locationUsersMap[location.id];

      if (!locationUser && location.enabled) {
        this.locationsToDisplay.push({ name: location.locationName, value: location.id });
      }
    }

    this.form = this.fb.group({
      name: [{
        value: this.user.name,
        disabled: true,
      }],
      email: [{
        value: this.user.email,
        disabled: true,
      }],
      role: [UserLocationRole.user],
      locations: [[]],
    });
  }

  sendInvite(): void {
    this.inProgress = true;
    const value = this.form.value;
    const data: EditAccountUserRequest = {
      adminAccess: false,
      locations: [
        ...value.locations.map(id => ({id, role: value.role})),
        ...this.user.locationUsers.map(({locationId: id, role}) => ({id, role})),
      ],
    };

    this.modalController.dismiss(data);
  }

  close(): void {
    this.modalController.dismiss();
  }

  get roleControl(): AbstractControl {
    return this.form.get('role') as AbstractControl;
  }

  get locationsControl(): AbstractControl {
    return this.form.get('locations') as AbstractControl;
  }

  get locationsControlValid(): boolean {
    return this.locationsControl.value.length > 0;
  }
}
